<template>
  <div class="h-toolbarBg">
    <div>
      <div class="col-lg-12 ">
        <div id='content' class="width-135">
          <ejs-dropdownlist id='games' :dataSource='data' :fields='fields' popupHeight='auto' :placeholder='waterMark' :change='changeFunc'></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <!--<ejs-toolbar>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-search' :tooltipText='$t("Track.search")' :click='buttonClk' operate='search'></e-item>
      </e-items>
    </ejs-toolbar>-->
  </div>
</template>
<script>
export default {
  name: 'MonitTableMenu',
  data() {
    return {
      waterMark: this.$t('Track.pleaseSelect'),
      height: '220px',
      fields: {
        text: 'Text',
        value: 'Value',
        isChecked: 'Selected'
      },
      data: [
        { Text: this.$t('Track.all'), Value: '0' },
        { Text: this.$t('Track.activation'), Value: '1' },
        { Text: this.$t('Track.hangup'), Value: '2' }
      ],
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  methods: {
    changeFunc(args) {
      this.$emit('methodEnum', args);
    }
  }
};
</script>
